import * as actionTypes from "~/store/action_types";

const expense_categories = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_EXPENSE_CATEGORIES_SUCCESS:
    case actionTypes.ANGULAR_INIT_EXPENSE_CATEGORIES: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { expense_categories = {} } = entities;

      return expense_categories;
    }
    case actionTypes.FETCH_EXPENSE_CATEGORY_SUCCESS:
    case actionTypes.ADD_EXPENSE_CATEGORY_SUCCESS:
    case actionTypes.EDIT_EXPENSE_CATEGORY_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { expense_categories = {} } = entities;
      return {
        ...state,
        ...expense_categories,
      };
    }
    case actionTypes.DELETE_EXPENSE_CATEGORY_LOADING:
    case actionTypes.DELETE_EXPENSE_CATEGORY_SUCCESS: {
      const { id, is_in_use = true } = action;
      const expenseCategory = state[id];
      if (expenseCategory) {
        if (is_in_use) {
          return { ...state, [id]: { ...expenseCategory, is_archived: true } };
        } else {
          const newState = { ...state };
          delete newState[id];
          return newState;
        }
      }
      return state;
    }
    case actionTypes.DELETE_EXPENSE_CATEGORY_FROM_EVENT_STREAM: {
      const { id } = action;
      const expenseCategory = state[id];
      if (expenseCategory) {
        const newState = { ...state };
        delete newState[id];
        return newState;
      }
      return state;
    }
    default:
      return state;
  }
};

export default expense_categories;
